import "bootstrap/dist/css/bootstrap.min.css";
import { useCallback, useEffect, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import {
  FaChevronLeft,
  FaChevronRight,
  FaFacebook,
  FaGlobe,
  FaInstagram,
  FaTiktok,
  FaWhatsapp,
  FaYoutube,
} from "react-icons/fa";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useLanguage } from "../component/LanguageProvider";
import logo from "../Images/Flyvia Logo.png";

export const CustomNavbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeItem, setActiveItem] = useState("home");
  const [scrolled, setScrolled] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  const { currentLang, changeLanguage } = useLanguage();
  const location = useLocation();
  const navigate = useNavigate();
  const isRTL = currentLang === "ar";

  const controlNavbar = useCallback(() => {
    const y = window.scrollY;
    setIsVisible(y <= lastScrollY || y <= 80);
    setScrolled(y > 50);
    setLastScrollY(y);
  }, [lastScrollY]);

  useEffect(() => {
    window.addEventListener("scroll", controlNavbar, { passive: true });
    return () => window.removeEventListener("scroll", controlNavbar);
  }, [controlNavbar]);

  const navItems = [
    { id: "home", path: "/", name: { en: "Home", ar: "الرئيسية" } },
    { id: "about", path: "/Aboutuspage", name: { en: "About", ar: "من نحن" } },
    {
      id: "services",
      path: "/ourservicepage",
      name: { en: "Services", ar: "الخدمات" },
    },
    {
      id: "blog",
      path: "/MainBlogsCardspage",
      name: { en: "Blog", ar: "المدونة" },
    },
    {
      id: "contact",
      path: "/#contact",
      name: { en: "Contact", ar: "اتصل بنا" },
    },
  ];

  useEffect(() => {
    const match = navItems.find((i) => i.path === location.pathname);
    setActiveItem(match ? match.id : "");
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const handleNavigation = (path, id) => {
    setActiveItem(id);
    setMenuOpen(false);
    if (path.includes("#contact")) {
      if (location.pathname === "/") {
        document
          .getElementById("contact")
          ?.scrollIntoView({ behavior: "smooth" });
      } else {
        navigate("/");
        setTimeout(
          () =>
            document
              .getElementById("contact")
              ?.scrollIntoView({ behavior: "smooth" }),
          350,
        );
      }
    } else {
      navigate(path);
    }
  };

  const handleLanguageChange = () => {
    const nl = currentLang === "en" ? "ar" : "en";
    changeLanguage(nl);
    document.documentElement.dir = nl === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = nl;
  };

  return (
    <>
      <div className={`flyvia-top-bar ${scrolled ? "top-bar-hidden" : ""}`}>
        <div className="top-bar-inner">
          <div className="top-bar-left">
            <span>✈ +34 614 909 102</span>
            <span className="d-none d-md-inline"> info@flyvia.com</span>
          </div>
          <div className="top-bar-right d-none d-md-flex">
            <a
              href="https://www.instagram.com/flyvia.services/"
              className="top-social-link"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61588256249191"
              className="top-social-link"
            >
              <FaFacebook />
            </a>
            <a
              href="https://www.youtube.com/@Flyvia-x8d/videos"
              className="top-social-link"
            >
              <FaYoutube />
            </a>
            <a
              href="https://www.tiktok.com/@flyvia.services"
              className="top-social-link"
            >
              <FaTiktok />
            </a>
            <a href="https://wa.me/34614909102" className="top-social-link">
              <FaWhatsapp />
            </a>
          </div>
        </div>
      </div>

      <nav
        className={`flyvia-nav  ${scrolled ? "nav-scrolled" : ""} ${isVisible ? "nav-visible" : "nav-hidden"}`}
        dir={isRTL ? "rtl" : "ltr"}
      >
        <div className="flyvia-nav-inner">
          <div
            className="flyvia-brand"
            onClick={() => handleNavigation("/", "home")}
          >
            <img src={logo} alt="FlyVia" className="flyvia-logo" />
          </div>

          <div className="flyvia-desktop-links">
            {navItems.map((item) => (
              <Link
                key={item.id}
                to={item.path}
                className={`flyvia-link ${activeItem === item.id ? "flyvia-link--active" : ""}`}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavigation(item.path, item.id);
                }}
              >
                {item.name[currentLang]}
              </Link>
            ))}
          </div>

          <div className="flyvia-nav-actions">
            <button className="flyvia-lang-btn" onClick={handleLanguageChange}>
              <FaGlobe size={14} />
              <span>{currentLang === "en" ? "العربية" : "English"}</span>
            </button>
            <button
              className="flyvia-cta-btn"
              onClick={() => handleNavigation("/#contact", "contact")}
            >
              {currentLang === "en" ? "Book Now" : "احجز الآن"}
            </button>

            <button
              className={`flyvia-hamburger d-lg-none`}
              onClick={() => setMenuOpen(true)}
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </nav>

      <Offcanvas
        show={menuOpen}
        onHide={() => setMenuOpen(false)}
        placement={isRTL ? "start" : "end"}
        className="flyvia-offcanvas"
      >
        <Offcanvas.Header className="flyvia-offcanvas-header">
          <div className="flyvia-brand">
            <img src={logo} alt="FlyVia" style={{ height: 90 }} />
          </div>
          <button
            className="flyvia-close-btn"
            onClick={() => setMenuOpen(false)}
          >
            ✕
          </button>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          <div className="flyvia-mobile-links">
            {navItems.map((item) => (
              <button
                key={item.id}
                className={`flyvia-mobile-link ${activeItem === item.id ? "active" : ""}`}
                onClick={() => handleNavigation(item.path, item.id)}
              >
                <span>{item.name[currentLang]}</span>
                {isRTL ? (
                  <FaChevronLeft size={11} />
                ) : (
                  <FaChevronRight size={11} />
                )}
              </button>
            ))}
          </div>
          <div className="flyvia-offcanvas-footer">
            <button
              className="flyvia-lang-mobile"
              onClick={handleLanguageChange}
            >
              <FaGlobe />
              <span>
                {currentLang === "en"
                  ? "تحويل للغة العربية"
                  : "Switch to English"}
              </span>
            </button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <style>{`
        .flyvia-top-bar {
          position: fixed;
          top: 0; left: 0; right:0;
          height: 36px;
          background: #ae0001;
          z-index: 1061;
          transition: transform 0.4s cubic-bezier(0.25, 1, 0.5, 1);
          font-family: var(--font-secondary);
        }
        .top-bar-hidden { transform: translateY(-100%); }

        .top-bar-inner {
          max-width: 1300px;
          margin: 0 auto;
          padding: 0 40px;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 11px;
          color: white;
          text-transform: uppercase;
          letter-spacing: 1px;
        }
        @media (max-width: 768px) {
          .top-bar-inner { padding: 0 15px; }
          .flyvia-top-bar { height: 32px; }
          .top-bar-left { font-size: 10px; }
        }

        .top-bar-right {
          display: flex;
          gap: 15px;
          align-items: center;
        }
        .top-social-link {
          color: white;
          text-decoration: none;
          transition: 0.3s;
          opacity: 0.8;
        }
        .top-social-link:hover {
          opacity: 1;
          transform: translateY(-2px);
        }

        .flyvia-nav {
          position: fixed;
          left: 0; right: 0;
          top: 36px;
          z-index: 1060;
          padding: 0px 10px;
          transition: all 0.4s cubic-bezier(0.25, 1, 0.5, 1);
          background: rgba(255, 255, 255, 0.05);
          backdrop-filter: blur(15px);
          -webkit-backdrop-filter: blur(15px);
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
          max-width: 1300px;
          border-radius: 20px;
          margin: 10px auto;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
          border: 1px solid rgba(255, 255, 255, 0.2);
          font-family: var(--font-primary);
        }

        @media (max-width: 991px) {
          .flyvia-nav { margin: 5px 10px; padding: 0 5px; border-radius: 15px; top: 32px; }
          .flyvia-logo { width: 80px !important; }
          .flyvia-nav-actions { gap: 8px; }
          .flyvia-cta-btn { padding: 7px 15px; font-size: 12px; }
        }

        .flyvia-nav.nav-scrolled {
          top: 0;
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(25px);
        }

        .nav-hidden { transform: translateY(-120%); }
        .nav-visible { transform: translateY(0); }

        .flyvia-nav-inner {
          max-width: 1400px;
          margin: 0 auto;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .flyvia-logo {
          width: 100px;
          object-fit: contain;
          cursor: pointer;
        }

        .flyvia-desktop-links {
          display: none;
          gap: 10px;
          background: rgba(255,255,255, 0.1);
          padding: 5px;
          border-radius: 50px;
          backdrop-filter: blur(15px);
        }
        @media (min-width: 992px) { .flyvia-desktop-links { display: flex; } }

        .flyvia-link {
          padding: 8px 20px;
          font-size: 14px;
          font-weight: 500;
          color: black;
          text-decoration: none !important;
          border-radius: 50px;
          transition: all 0.3s;
          font-family: var(--font-secondary);
        }
        .nav-scrolled .flyvia-link { color: #000 ; }

        .flyvia-link--active {
          background: #ae0001 !important;
          color: white !important;
        }

        .flyvia-nav-actions { display: flex; align-items: center; gap: 15px; }

        .flyvia-lang-btn {
          background: none;
          border: 1px solid rgba(255,255,255,0.3);
          color: white;
          padding: 7px 15px;
          border-radius: 50px;
          font-size: 13px;
          display: none;
          align-items: center;
          gap: 8px;
          transition: 0.3s;
          font-family: var(--font-secondary);
        }
        @media (min-width: 992px) { .flyvia-lang-btn { display: flex; } }
        
        .flyvia-cta-btn {
          background: #ae0001;
          color: white;
          border: none;
          padding: 9px 25px;
          border-radius: 50px;
          font-weight: 600;
          font-size: 14px;
          display: none;
          font-family: var(--font-secondary);
          transition: transform 0.3s;
        }
        .flyvia-cta-btn:hover { transform: translateY(-2px); box-shadow: 0 10px 20px rgba(174,0,1,0.3); }
        @media (min-width: 992px) { .flyvia-cta-btn { display: block; } }

        .flyvia-hamburger {
          background: none;
          border: none;
          display: flex;
          flex-direction: column;
          gap: 5px;
          padding: 5px;
        }
        .flyvia-hamburger span {
          background: #ae0001;
          display: block;
          height: 2px;
          width: 22px;
          border-radius: 2px;
        }

        .flyvia-offcanvas {
          background: linear-gradient(180deg, #0f1218 0%, #1a1f29 100%) !important;
          color: white !important;
          font-family: var(--font-primary);
          width: 300px !important;
          border-left: 1px solid rgba(255,255,255,0.05);
          z-index: 100001 !important; /* Above everything */
        }
        .flyvia-offcanvas-header {
          padding: 30px !important;
          border-bottom: 1px solid rgba(255,255,255,0.05);
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .flyvia-mobile-links {
          padding: 20px 0;
        }
        .flyvia-mobile-link {
          width: 100%;
          padding: 18px 30px;
          background: none;
          border: none;
          color: rgba(255,255,255,0.7);
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-family: var(--font-secondary);
          text-transform: uppercase;
          letter-spacing: 2px;
          font-size: 13px;
          transition: 0.3s;
          text-align: left;
        }
        .flyvia-mobile-link:hover, .flyvia-mobile-link.active {
          color: #ae0001;
          background: rgba(174,0,1,0.08);
          padding-left: 35px;
        }
        .flyvia-lang-mobile {
          width: calc(100% - 40px);
          margin: 20px;
          padding: 15px;
          background: rgba(255,255,255,0.03);
          border: 1px solid rgba(255,255,255,0.1);
          color: white;
          border-radius: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 12px;
          font-family: var(--font-secondary);
          font-size: 12px;
          text-transform: uppercase;
          letter-spacing: 1px;
          transition: 0.3s;
        }
        .flyvia-lang-mobile:active { transform: scale(0.98); background: rgba(255,255,255,0.08); }
        .flyvia-close-btn { 
          background: rgba(255,255,255,0.05); 
          border: 1px solid rgba(255,255,255,0.1); 
          color: white; 
          width: 40px;
          height: 40px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          transition: 0.3s;
        }
        .flyvia-close-btn:hover { background: #ae0001; border-color: #ae0001; }
      `}</style>
    </>
  );
};
